type Add<T = any> = () => Promise<T>

interface QueuedObject<T> {
  func: Add<T>
  resolve: (value: T) => void
}

export default class Throttle {
  q: QueuedObject<any>[] = []
  current?: Promise<any>

  constructor() {}

  add<T>(func: Add<T>) {
    return new Promise<T>((resolve) => {
      this.q.push({func, resolve})

      if (!this.current) {
        this.run(func, resolve)
      }
    })
  }

  private async run<T>(func: Add<T>, resolve: (value: Promise<T>) => void) {
    this.current = func()
      .then((data) => this.next(data))
      .catch((e: any) => {
        this.next(null)
        throw e
      })
      .finally(() => {
        this.current = undefined
      })

    resolve(this.current)
  }

  private next<T>(data: T) {
    this.q.splice(0, 1)
    if (this.q[0]) {
      const {func, resolve} = this.q[0]
      this.run(func, resolve)
    }
    return data
  }
}
